import { Box } from '@chakra-ui/react';
import React from 'react';
import { useSelector } from 'react-redux';

import { AppState } from '../../app.types';
import { ModalOverlayBackground } from './modal-manager.styled';
import { ModalManagerState } from './modal-manager.types';

export type Props = {
    variants: {
        [variant: string]: (props?: any) => JSX.Element
    }
};

export const ModalManager = ({ variants }: Props) => {
    const ref = React.useRef(null);
    const { currentModal } = useSelector<AppState, ModalManagerState>(state => state.modalManager);

    if (!currentModal) {
        return null;
    }

    const SelectedModal = variants?.[currentModal.variant];

    if (!SelectedModal) {
        throw new Error('ModalManager is unable to find variant ' + currentModal.variant);
    }

    return (
        <ModalOverlayBackground
            data-testid={'modal-manager'}
            data-modal-variant={currentModal.variant}
        >
            <Box ref={ref}>
                <SelectedModal {...currentModal.modalProps} />
            </Box>
        </ModalOverlayBackground>
    );
};
